import React, { Component } from 'react'
import { CreateContent } from '../../components'
import { db } from '../../config/firebaseconfig'
import PropTypes from 'prop-types'
import { bindActionCreators } from 'redux'
import { connect } from 'react-redux'
import * as createContentActionCreators from '../../redux/modules/createContent'
import { EditorState, convertToRaw, ContentState } from 'draft-js';
import saveContentItem from '../../helpers/saveContentItem'

const uuid = require('uuid/v1')

// Need to handle the view in each box when not editing
// When editor is empty, make it so it's still clickable (and/or add edit button?)
// simulate placeholder text. When it's empty, push in placeholder, and when it's being edited, kill placeholder

// Hints

// Make choices correct or incorrect

// Open editor by clicking just about anywhere on the card
// When editor opens, put the cursor there

// Make universal feedback

// Support True/False

// Make image uploading work

// display item id

// add skill tagging

// add createdBy


class CreateContentContainer extends Component {
  constructor(props) {
    super(props)

    this.state = {
      editorState: EditorState.createEmpty(),
      itemName: '',
      itemCode: '',
      quillText: '',
    }

    this.onEditorStateChange = this.onEditorStateChange.bind(this)
    this.toggleShuffle = this.toggleShuffle.bind(this)
    this.handleContentTypeClick = this.handleContentTypeClick.bind(this)
    this.handleItemTypeChange = this.handleItemTypeChange.bind(this)
    this.handleChangeActiveEditor = this.handleChangeActiveEditor.bind(this)
    this.handleAddAnswerChoice = this.handleAddAnswerChoice.bind(this)
    this.handleDeleteAnswerChoice = this.handleDeleteAnswerChoice.bind(this)
    this.handleClickSave = this.handleClickSave.bind(this)
    this.handleNewItemClick = this.handleNewItemClick.bind(this)
    this.handleNewItemWarnClick = this.handleNewItemWarnClick.bind(this)
    this.closeTheModal = this.closeTheModal.bind(this)
    this.handleClickThumb = this.handleClickThumb.bind(this)
    this.handleInfoChange = this.handleInfoChange.bind(this)
    this.handleQuillChange = this.handleQuillChange.bind(this)
  }

  componentDidMount() {
    if (!this.props.itemId) {
      this.props.setItemId(uuid())
    }

    // Get nodes to use to tag the items
    this.props.fetchingNodes()
    let fetchedNodes = {}
    db.collection('knowledgeMapNodes').get()
      .then((querySnapshot) => {
        querySnapshot.forEach((doc) => {
          const data = doc.data()
          fetchedNodes[data.id] = data
        })
        this.props.fetchingNodesSuccess(fetchedNodes)
      })
      .catch((err) => this.props.fetchingNodesError(err))

  }

  handleQuillChange(value) {
    this.setState({quillText: value})
  }

  handleInfoChange(e) {
    this.setState({
      [e.target.name]: e.target.value
    })
  }

  onEditorStateChange(editorState) {
    this.setState({
      editorState,
    });
  }

  toggleShuffle() {
    this.props.setShuffle(!this.props.shuffle)
  }

  handleContentTypeClick(type) {
    this.props.setContentType(type)
  }

  handleItemTypeChange (e) {
    this.props.setItemType(e.target.value)
  }

  closeOpenEditor() {
    if (this.props.activeEdit.type === 'question') {
      const questionHTML = this.state.quillText
      this.props.setQuestion(questionHTML)
      return { question: questionHTML }
    } else {
      let newAnswers = []
      for (var i = 0; i < this.props.answers.length ; i++) {
        if (i === this.props.activeEdit.index) {
          let newAnswer
          if (this.props.activeEdit.type === 'answer') {
            newAnswer = {
              ...this.props.answers[i],
              answer: this.state.quillText,
            }
          } else if (this.props.activeEdit.type === 'feedback') {
            newAnswer = {
              ...this.props.answers[i],
              feedback: this.state.quillText,
            }
          }
          newAnswers.push(newAnswer)
        } else {
          newAnswers.push(this.props.answers[i])
        } 
      }
      this.props.activeEdit.type ? this.props.setAnswers(newAnswers) : null
      return { answers: newAnswers }
    }
  }

  handleChangeActiveEditor (e, newActiveEditor) {
    this.closeOpenEditor()
    this.props.setActiveEdit(newActiveEditor)

    let newQuillText

    if (newActiveEditor.type === 'question') {
      newQuillText = this.props.question
    } else if (newActiveEditor.type === 'answer' || newActiveEditor.type === 'feedback') {
      newQuillText = this.props.answers[newActiveEditor.index][newActiveEditor.type]
    }
    this.setState({
        quillText: newQuillText,
      })
  }

  handleAddAnswerChoice(e) {
    let newAnswers = this.props.answers.slice(0)
    newAnswers.push({
      correct: false,
      answer: 'Add a choice here',
      feedback: 'Explain why right or wrong',
    })
    this.props.setAnswers(newAnswers)
  }

  handleDeleteAnswerChoice(e, index) {
    let answers = this.props.answers.slice(0)
    answers.splice(index, 1)
    this.props.setAnswers(answers)
  }

  handleClickSave(e) {
    const replacementContent = this.closeOpenEditor()
    this.props.setActiveEdit({type: '', index: 0})
    this.setState({
      editorState: EditorState.createEmpty()
    })
    this.props.isSavingSetTrue()
    const itemToSave = {
      itemId: this.props.itemId,
      contentType: this.props.contentType,
      itemType: this.props.itemType,
      shuffle: this.props.shuffle,
      question: this.props.question,
      answers: this.props.answers,
      startingLetter: this.props.startingLetter,
      nodeTags: this.props.nodeTags,
      name: this.state.itemName,
      code: this.state.itemCode,
    }
    if (replacementContent) {
      replacementContent.question ? itemToSave.question = replacementContent.question : null
      replacementContent.answers ? itemToSave.answers = replacementContent.answers : null
    }

    saveContentItem(itemToSave)
      .then( () => {
        const date = new Date
        const timestamp = date.getTime()
        this.props.savingSuccess(timestamp)
      })
      .catch( (error) => {
        this.props.savingError(error)
      })
  }

  handleNewItemClick() {
    if (this.props.noChanges) {
      this.props.createNewItem()
      this.props.setItemId(uuid())
    } else {
      const modalMessage = 'newItemClickWarn'
      this.props.openModal(modalMessage)
    }
  }

  handleNewItemWarnClick(e) {
    if (e.target.name === 'Cancel') {
      this.props.closeModal()
    } else if (e.target.name === 'Continue') {
      this.props.createNewItem()
      this.props.setItemId(uuid())
    }
  }

  closeTheModal() {
    this.props.closeModal()
  }

  handleClickThumb(index, correctQ) {
    let newAnswer = this.props.answers[index]
    newAnswer.correct = correctQ
    this.props.setAnswer(index, newAnswer)
  }


  render() {
    return <CreateContent 
        itemId={this.props.itemId}
        contentType={this.props.contentType}
        itemType={this.props.itemType}
        shuffle={this.props.shuffle}
        question={this.props.question}
        answers={this.props.answers}
        activeEdit={this.props.activeEdit}
        isFetching={this.props.isFetching}
        isSaving={this.props.isSaving}
        error={this.props.error}
        lastSaved={this.props.lastSaved}
        noChanges={this.props.noChanges}
        toggleShuffle={this.toggleShuffle}
        toggleContentType={this.handleContentTypeClick}
        toggleItemType={this.handleItemTypeChange}
        toggleActiveEditor={this.handleChangeActiveEditor}
        editorState={this.state.editorState}
        onEditorStateChange={this.onEditorStateChange}
        handleAddAnswerChoice={this.handleAddAnswerChoice}
        handleDeleteAnswerChoice={this.handleDeleteAnswerChoice}
        handleClickSave={this.handleClickSave}
        handleNewItemClick={this.handleNewItemClick}
        handleNewItemWarnClick={this.handleNewItemWarnClick}
        closeTheModal={this.closeTheModal}
        modalOpen={this.props.modalOpen}
        modalMessage={this.props.modalMessage}
        handleClickThumb={this.handleClickThumb}
        startingLetter={this.props.startingLetter}
        setStartingLetter={this.props.setStartingLetter}
        nodes={this.props.nodes}
        nodeTags={this.props.nodeTags}
        addNodeTag={this.props.addNodeTag}
        deleteNodeTag={this.props.deleteNodeTag}
        itemName={this.state.itemName}
        itemCode={this.state.itemCode}
        handleInfoChange={this.handleInfoChange}
        quillText={this.state.quillText}
        handleQuillChange={this.handleQuillChange}
      />
  }
}

export default connect(
  (state) => ({
    itemId: state.createContent.itemId,
    contentType: state.createContent.contentType,
    itemType: state.createContent.itemType,
    shuffle: state.createContent.shuffle,
    question: state.createContent.question,
    answers: state.createContent.answers,
    activeEdit: state.createContent.activeEdit,
    isFetching: state.createContent.isFetching,
    isSaving: state.createContent.isSaving,
    error: state.createContent.error,
    lastSaved: state.createContent.lastSaved,
    noChanges: state.createContent.noChanges,
    modalOpen: state.createContent.modalOpen,
    modalMessage: state.createContent.modalMessage,
    startingLetter: state.createContent.startingLetter,
    nodes: state.createContent.nodes,
    nodeTags: state.createContent.nodeTags,

  }),
  (dispatch) => bindActionCreators(createContentActionCreators, dispatch)
)(CreateContentContainer)

/*

export default connect(
  (state) => ({
    isFetching: state.users.isFetching,
    error: state.users.error,
    notFound: state.users.notFound,
    isAuthed: state.users.isAuthed,
    role: state.users.role
  }),
  (dispatch) => bindActionCreators(usersActionCreators, dispatch)
)(SignInContainer)



import React, { Component } from 'react'
import firebase from 'firebase'
import { ref, db } from '../config/firebaseconfig'
import authUser from '../helpers/authUser'
import PropTypes from 'prop-types'
import { bindActionCreators } from 'redux'
import { connect } from 'react-redux'
import * as usersActionCreators from '../redux/modules/users'
import fetchUser from '../helpers/fetchUser'
import { SignIn, Login } from '../components'
import { Redirect } from 'react-router-dom'


*/


// WEBPACK FOOTER //
// ./src/containers/Content/CreateContentContainer.js